import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import BgImage from '../../assets/images/bg.jpeg'

const useStyles = makeStyles((theme) => ({
  bg: {
    [theme.breakpoints.up('sm')]: {
      backgroundRepeat: 'no-repeat',
      paddingBottom: '40px',
      backgroundSize: 'cover',
      backgroundImage: `url(${BgImage})`,
      backgroundPosition: 'center',
    }
  }
}));

const Background = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={classes.bg}>
      {children}
    </div>
  );
};

export default Background;
